import { IconLink, IconLinkOff } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import IconButton from '../../../components/Buttons/IconButton';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../../components/DataTable/TableComponent';
import Pagination from '../../../components/Pagination/Pagination';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const InfluencerListOfAgentTable = ({ agentId }) => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getInfluencerList() {
        loadingShow();
        let url = `${urlApi.influencerListOfAgent}${agentId}?page=${activePage}&limit=${perPage}`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getInfluencerList();
        return () => {
            setTableData({ data: [], totalCount: 0 });
        };
    }, []);

    const unLink = async (influencerId) => {
        loadingShow();
        let resp = await getApi(`${urlApi.unLinkAgentInfluencer}${agentId}/${influencerId}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getInfluencerList();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Channel Name", center: "true", selector: (row) => row?.channel_name, grow: 1.4, cell: (row) => (
                <Link to={"/influencer/" + row?.influencerId} target='_blank'> <p className="mb-0">{row?.channelName}</p></Link>
            )
        }, {
            name: "Logo", center: "true", selector: (row) => row?.category, grow: 0.6, cell: (row) => (
                <img src={row?.channelLogo || "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} className='w-10 aspect-square rounded-full my-1 object-cover' alt="" />
            )
        }, {
            name: "Mobile", center: "true", selector: (row) => row?.title, grow: 1, cell: (row) => (
                <p className="mb-0">{row?.phone ?? "--"}</p>
            )
        }, {
            name: "Amount", center: "true", selector: (row) => row?.amount, grow: 0.4, cell: (row) => (
                <p className="mb-0">₹{row?.totalPay || 0}</p>
            )
        }, {
            name: "Link", center: "true", selector: (row) => row?.link, grow: 0.4, cell: (row) => (
                <Link to={row?.channelLink} target="_blank" rel="noopener noreferrer" className="mb-0"><IconLink /></Link>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.link, grow: 1, cell: (row) => (
                <ConfirmationModal buttonComponent={<IconButton icon={<IconLinkOff size={20} />} text={"Unlink Influencer"} />} confirmationText={`Are you sure want to Unlink ${row?.channelName}`} onConfirm={() => unLink(row?.influencerId)} />
            )
        },
    ];

    return (
        <div className='rounded-2xl'>

            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isHeader={true}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </div>
    )
}

export default InfluencerListOfAgentTable